import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { productCardStyles } from "@dana/Overrides/Widgets/ProductList/ProductListProductCard";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

productCardStyles.gridContainer = mergeToNew(productCardStyles.gridContainer, {
    css: css`
        padding: 16px;
        background: ${themeColors.primary.white};
        position: relative;
    `,
});

productCardStyles.leftColumnGridItem = mergeToNew(productCardStyles.leftColumnGridItem, {
    css: css`
        padding-right: 24px;

        [data-test-selector="productListProductImage"] {
            row-gap: 16px;
        }

        .badge-wrapper {
            right: -9px !important;
            top: 9px !important;
            text-wrap: auto;
        }

        .discontinued-badge,
        .interchange-badge {
            right: -9px;
            top: 9px;
        }

        .interchange-badge.with-overlay {
            top: 56px;
        }
    `,
});

productCardStyles.actionsGridItem = mergeToNew(productCardStyles.actionsGridItem, {
    css: css`
        .plp-cart-actions {
            margin-top: 0;
        }
    `,
});

productCardStyles.attributesGridItem = mergeToNew(productCardStyles.attributesGridItem, {
    css: css`
        width: 100%;
    `,
});

productCardStyles.rightColumnGridItem = mergeToNew(productCardStyles.rightColumnGridItem, {
    css: css`
        padding-top: 35px;
    `,
});

productCardStyles.infoGridItem = mergeToNew(productCardStyles.infoGridItem, {
    css: css`
        .product-brand-info-wrapper {
            flex-direction: column;
            row-gap: 16px;
        }
    `,
});
